import { axios } from 'lib/axios';

export const verifyEmailOTPLogin = async (data) => {
  return await axios.post('/user/emailOTPLogin/verifyLogin', data);
};
